import { Injectable } from "@angular/core";

export enum StatusPageServiceStatusIndicator {
  MAJOR = "major",
  MINOR = "minor",
  NONE = "none"
}

export type StatusPageServiceStatus = {
  page: {
    id: string;
    name: string;
    url: string;
    updated_at: string;
  };
  status: {
    description: string;
    indicator: StatusPageServiceStatusIndicator;
  };
};

@Injectable()
export class StatusPageService {
  async load(): Promise<StatusPageServiceStatus> {
    return await fetch(
      "https://zwh0h46ts5sx.statuspage.io/api/v2/status.json"
    ).then((response) => response.json());
  }
}
